<script setup lang="ts">
import {
  PhxsgTextProps as PhxsgCoreTextProps,
  PhxsgText as PhxsgCoreText,
} from '@sg-core/src/View/Components/Atoms/Text';

import './text.css';

export type PhxsgTextProps = Omit<PhxsgCoreTextProps, 'variant' | 'size'> & {
  variant?: 'label' | 'specs' | 'body' | 'cta';
  size?: 'extra-small' | 'small' | 'medium';
  color?: 'primary' | 'secondary' | 'subtle' | 'muted';
};

const { variant = 'body', size = 'medium', color = 'primary' } = defineProps<PhxsgTextProps>();
</script>

<template>
  <PhxsgCoreText
    :class="{
      [`phxsg-text--${variant}-${size}`]: variant && size,
      [`phxsg-text--${color}`]: color && color !== 'primary',
    }"
    v-bind="$props"
  >
    <slot />
  </PhxsgCoreText>
</template>
